package br.com.texeratx.boardgametimeapp.core.image

import androidx.compose.runtime.Composable
import androidx.compose.runtime.DisposableEffect
import androidx.compose.runtime.remember
import kotlinx.browser.document
import org.khronos.webgl.ArrayBuffer
import org.khronos.webgl.Uint8Array
import org.w3c.dom.HTMLInputElement
import org.w3c.files.FileReader

actual val hasCameraSupport: Boolean = false

@Composable
actual fun rememberCameraLauncher(onResult: (PickedImage?) -> Unit): () -> Unit = {}

@Composable
actual fun rememberImagePickerLauncher(
    onResult: (PickedImage?) -> Unit
): () -> Unit {

    val input = remember {
        (document.createElement("input") as HTMLInputElement).apply {
            type = "file"
            accept = "image/*"
        }
    }

    DisposableEffect(Unit) {

        input.onchange = onchange@{ _ ->
            val file = input.files?.item(0)
            if (file == null) {
                onResult(null)
                return@onchange null
            }

            val reader = FileReader()

            reader.onload = onload@{ _ ->
                val result = reader.result
                if (result == null) {
                    onResult(null)
                    return@onload null
                }

                val buffer: ArrayBuffer = result.unsafeCast<ArrayBuffer>()
                val u8 = Uint8Array(buffer)

                // ✅ forma mais robusta no Kotlin/JS (evita operador get() dando Any.get)
                val dyn = u8.asDynamic()
                val bytes = ByteArray(u8.length) { i ->
                    (dyn[i] as Int).toByte()
                }

                onResult(
                    PickedImage(
                        bytes = bytes,
                        fileName = file.name,
                        mimeType = file.type.ifBlank { "image/*" }
                    )
                )

                null
            }

            reader.onerror = { _ ->
                onResult(null)
                null
            }

            reader.readAsArrayBuffer(file)
            null
        }

        onDispose {
            input.onchange = null
        }
    }

    return {
        input.value = "" // permite escolher o mesmo arquivo novamente
        input.click()
    }
}
